// @flow
import React from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
// @ts-ignore
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Card, FormControl, TableContainer, Table, TableHead,
  TableBody, Paper, TextField, Chip,
  Box, CardContent, TablePagination, Stack,
  CircularProgress,
  FormControlLabel,
  Switch
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { TrueffortButton, TrueffortButtonSmall, TrueffortSearchInput, TrueffortTableHeadCell, TrueffortCardTable, 
  TrueffortInputLabel, StyledTableRow, StyledTableCell } from "../../MUIstyle/MUICustom";
import { Add, DeleteOutline, Clear, Edit, Delete, Save } from '@mui/icons-material';
import Select from "react-select";
import { styleReactSelect } from "../../MUIstyle/GlobalStyles";
import CardEmpty from "../custom/CardEmpty";
import WorkstationService from "../../services/workstation.service";
import UserService from "../../services/user.service";
import { useState, useMemo } from "react";
import { ID_ROLE_USER } from "../../util/Constants";
import { useAuthContext } from "../../contexts/AuthenticationContext";

function WorkstationInvisibleTab() {
    const { t } = useTranslation();
    const { user } = useAuthContext();
    const workstationService = React.useMemo(() => new WorkstationService(), []);
    const userService = useMemo(() => new UserService(), []);
    const [users, setUsers] = useState([]);
    const [userValue, setUserValue] = useState(null);
    const [state, setState] = React.useState({ loading: false, isEditing: false, isUpdating: false, showFormAdd: false });
    const [rowsPerPageWorkstation, setRowsPerPageWorkstation] = React.useState(10);
    const [workstationsPage, setWorkstationsPage] = React.useState(0);
    const [workstationsCount, setWorkstationsCount] = React.useState(0);
    const [showLoader, setShowLoader] = React.useState(false);
    const [workstations, setWorkstations] = React.useState([]);
    const [workstationsFiltered, setWorkstationsFiltered] = React.useState([]);
    const [isEnabledW, setIsEnabledW] = useState(false);
    let addMasive = false;
    React.useEffect(() => {
        fillWorkstation();
        fillUsers();
    }, [])

    const fillUsers = () => {
      // @ts-ignore
      userService.getAll().then(({ data: response }) => {
          if (Array.isArray(response.data)) {
              setUsers(response.data.filter((u) => u.isInvisible).map((usr) => {
                  return {
                      value: usr.idUser, label: usr.fullName
                  }
              }));
          }
      }).catch(({data:response}) => {
          console.error(response);
      }).finally(() => setShowLoader(false));
  }


    const fillWorkstation = () => {
      workstationService.getAllInvisible().then(({ data: response }) => {
        if (Array.isArray(response.data)) {
          setWorkstations(response.data);
          setWorkstationsFiltered(response.data);
          setWorkstationsCount(response.data.length);
        }
    });
    }

    const handleSearchKeyword = (search) => {
      if (search == "") { return workstations; }
      let search_ = search.toLowerCase();
      let items = workstations.filter((data) => data.uuid?.toLowerCase().includes(search_.toLowerCase()) ||
            data.hostname?.toLowerCase().includes(search_.toLowerCase()) || 
            data.user?.fullName.toLowerCase().includes(search_.toLowerCase()));

        setWorkstationsFiltered(items);
    }

    const handleSubmit = (values) => {
        const dataRequest = {
          uuid: values.uuid,
          isEnabled: isEnabledW,
          idUser: userValue?.value,
          idInstance: null
        };
        workstationService.getCreateInvisible(dataRequest).then(({ data: response }) => {
          formik.setSubmitting(false);
          formik.resetForm();
          if (response?.internalError && response.message != null) {
              toast.error(response.message);
              console.log("Error #Workstation handleEdit" + JSON.stringify(response));
          } else {
              toast.success(t("workstations.add_workstation_success"));
          }
          setState({ ...state, isUpdating: false, isEditing: false, isCreating: false, showFormAdd: false });
          setIsEnabledW(false);
          fillWorkstation();
      });
    }

    const handleEdit = (values) => {
        const dataRequest = {
          uuid: values.uuid,
          isEnabled: isEnabledW,
          idUser: userValue?.value,
          idInstance: null
        };

        workstationService.getUpdateInvisible(dataRequest).then(({ data: response }) => {
          formik.setSubmitting(false);
          formik.resetForm();
          if (response.internalError != null && response.internalError && response.message != null) {
              toast.error(response.message);
              console.log("Error #workstation handleEdit" + JSON.stringify(response));
          } else {
              toast.success(t("workstations.update_workstation_success"));
          }
          setState({ ...state, isUpdating: false, isEditing: false });
          setIsEnabledW(false);
          fillWorkstation();
      });
    }

    const formik = useFormik({
        initialValues: {
            uuid: '',
            hostname: '',
            idUser: 0,
            isEnabled: false
        },
        onSubmit: handleSubmit
    });

    const prepareEdit = (pro) => {
        pro["isEditing"] = true;
        formik.setValues({uuid: pro.uuid, isEnabled: pro.isEnabled, hostname: pro.hostname, idUser: pro?.user?.idUser});
        setIsEnabledW(pro.isEnabled);
        setState({ ...state, isUpdating: true, isEditing: true });
        let us = users.find((usr) => usr.value == pro?.user?.idUser && pro?.user?.idUser != null);
        if (us) {
          setUserValue({value: us.value, label: us.label});
        }
    }

    const handleChangeProfilesRowsPerPage = (event) => {
        setRowsPerPageWorkstation(parseInt(event.target.value, 10));
        setWorkstationsPage(0);
    }
    
    const handleChangeworkstationsPage = (event, newPage) => {
        setWorkstationsPage(newPage);
    }

    const [showFormMasive, setShowFormMasive] = useState(false);
    const [valueMultiple, setValueMultiple] = useState("");

    return (
        <Card sx={{ padding: "8px", background: "#F5F5F5", overflow: "unset" }}>
            <Grid container spacing={1} rowSpacing={3} style={{ marginBottom: "0.4em" }} justifyContent='space-evenly'>
                <Grid item xs={12} sm md lg={7}>
                    <FormControl fullWidth size="small">
                        {<TrueffortSearchInput
                            id="search-profile-input"
                            fullWidth
                            variant="outlined"
                            size="small"
                            onChange={(event) => handleSearchKeyword(event.target.value)}
                            placeholder={t("search")}
                        />}
                    </FormControl>
                </Grid>
                {addMasive &&
                  <Grid item xs={12} sm md lg={2.5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <TrueffortButtonSmall
                        color="secondary"
                        variant={"contained"}
                        onClick={() => setShowFormMasive(true)}
                        disabled={state.isEditing}
                        startIcon={<Add />}
                        style={{ fontSize: "11px" }}
                    >{"Añadir masivamente usuarios invisibles"}</TrueffortButtonSmall>
                  </Grid>
                }

                {<Grid item xs={12} sm md lg={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <TrueffortButtonSmall
                        color="secondary"
                        variant={"contained"}
                        onClick={() => {
                          workstationService.getCodeUuid().then((resp) => {
                            if (resp.internalError) {
                              console.log(resp.message);
                            } else {
                              formik.setValues({...formik.values, uuid: resp.data});
                              setState({ ...state, isUpdating: false, isCreating: true, showFormAdd: true });
                            }  
                          })
                        }}
                        disabled={state.isEditing}
                        startIcon={<Add />}
                        style={{ fontSize: "11px" }}
                    >{t("workstations.add_workstation")}
                    </TrueffortButtonSmall>
                </Grid>}
                {state.showFormAdd &&
                <Grid item xs={12}>
                  <Paper style={{ marginBottom: "0.4em" }}>
                    <CardContent>
                      <p style={{fontSize: '16px'}}>{t("user_page.user_create")}</p>
                      <Grid container spacing={1}>
                        <Grid item xs={3.5}>
                          <TextField 
                              id={"field-uuid-edi"}
                              name="name"
                              size="small"
                              disabled
                              value={formik.values.uuid}
                              fullWidth
                              sx={{ background: '#F5F5F5'}}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <TextField 
                              id={"field-uuid-edi"}
                              name="name"
                              size="small"
                              disabled
                              value={formik.values.hostname}
                              fullWidth
                              sx={{ background: '#F5F5F5'}}
                          />
                        </Grid>
                        <Grid item xs={2.5}>
                          <TrueffortInputLabel shrink labelString={"Usuarios"} />
                          <Select
                              placeholder={"Seleccione el usuario"}
                              value={userValue}
                              options={users}
                              onChange={(option) => setUserValue(option)}
                              styles={styleReactSelect}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel control={<Switch color='success'
                            value={isEnabledW}
                            onChange={(ev) => setIsEnabledW(ev.target.checked)}
                          />} label={t("workstations.enabled")} />
                        </Grid>
                        <Grid item xs={2} style={{
                            display: "flex", alignItems: "flex-end", justifyContent: "center"
                        }}>
                            <Stack spacing={1} direction={{ xs: 'column', lg: 'row' }} >
                                <TrueffortButton size="small"
                                    variant="contained"
                                    color='primary'
                                    onClick={() => handleSubmit(formik.values)}
                                >{t("elements.buttons.save")}</TrueffortButton>
                                <TrueffortButton size="small"
                                    onClick={() => {
                                        formik.resetForm();
                                        setState({ ...state, showFormAdd:false});
                                    }}
                                    label={t("elements.buttons.cancel")}
                                    variant="outlined"
                                    color="error"
                                ><Clear size="small" /></TrueffortButton>
                            </Stack>
                        </Grid>
                      </Grid>
                    </CardContent>
                    </Paper>
                </Grid>}
                {showFormMasive && <Grid container lg={12} xs={12} spacing={1}>
                  
                    <Card style={{width:'100%', display:'flex', flexDirection:'row'}}>
                      <Grid item xs={10} lg={10}>      
                      <TextField 
                        fullWidth
                        value={valueMultiple}
                        onChange={(ev) => {setValueMultiple(ev.target.value.replace(/(\r\n|\r|\n)/g, ""));}}
                        multiline={true} 
                        minRows={3}
                      /></Grid>
                      <Grid item xs={2} lg={2}>
                        <TrueffortButton size="small"
                          variant="contained"
                          color='primary'
                          onClick={async () => {
                            let fails = "";
                            try {
                            console.log(valueMultiple.replaceAll(/(\r\n|\r|\n)/g, ""));
                            let usuarios = valueMultiple.replace(" ", "").split(";");
                            for (let user_ of usuarios) {
                              console.log(user_);
                              let usArray = user_.split(",");
                              if (usArray.length == 4) {

                                let us = { name: usArray[0].replace(/\r\n/g, ""), lastName: usArray[1], email: usArray[2], isInvisible: true, idInstance: user?.instance?.idInstance,
                                  idRole: ID_ROLE_USER, idDepartament: usArray[3]
                                }
  
                                let resp_ = await userService.createInivitation(us);
                                console.log(resp_);
                                if (resp_.status == 200) {
                                  let usNew = resp_.data?.data;
                                  console.log(usNew);
                                  let respWork = await workstationService.getCodeUuid();
                                  console.log(respWork)
                                  if (respWork.status == 200) {
                                    let uuid = respWork.data;
                                    console.log(uuid);
                                    let obj = {
                                      idInstance: user?.instance.idInstance, idUser: usNew.idUser, isEnabled: true, uuid
                                    };
                                    let respUpd = await workstationService.getCreateInvisible(obj);
                                    console.log(respUpd)

                                    if (respUpd.status != 200) {
                                      fails += usArray[2] + ";";
                                    }
                                  }
                                }
                              }
                            }
                            setShowFormMasive(false);
                            toast.success("Proceso concluido");
                            
                          } catch(err) {
                            toast.error("Algunos usuarios no se agregaron o fallaron al relacionar al estación de trabajo => " + fails);
                            setShowFormMasive(false);
                          }
                          
                          }}
                      >{"Crear"}</TrueffortButton>
                      </Grid>
                    </Card>
                </Grid>}
                {showLoader && 
                    <Stack alignItems={"center"} justifyContent={"center"} style={{height:'300px'}}>
                        <CircularProgress />
                    </Stack>
                }
                {!showLoader && workstations.length == 0 && 
                    <CardEmpty><div>{t("msg.info.empty_response")}</div></CardEmpty>}
                {!showLoader && workstations.length > 0 && <TrueffortCardTable>
                    <Grid container spacing={1} rowSpacing={3} style={{ margin: "0.4em 0.2em", width: '100%' }}>
                        <TableContainer component={Paper} sx={{ overflow: "unset" }}
                        >
                            <Table
                                responsive="true"
                            >
                                <TableHead>
                                    <StyledTableRow sx={{backgroundColor: '#DCDCDC !important'}}>
                                        <TrueffortTableHeadCell>{t("workstations.uuid")}</TrueffortTableHeadCell>
                                        <TrueffortTableHeadCell>{t("workstations.hostname")}</TrueffortTableHeadCell>
                                        <TrueffortTableHeadCell>{t("workstations.user")}</TrueffortTableHeadCell>
                                        <TrueffortTableHeadCell>{t("workstations.status")}</TrueffortTableHeadCell>
                                        <TrueffortTableHeadCell>{t("actions")}</TrueffortTableHeadCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                  {workstationsFiltered.slice(workstationsPage * rowsPerPageWorkstation, 
                                        workstationsPage * rowsPerPageWorkstation + rowsPerPageWorkstation).map((wo) => (
                                    !wo.isEditing ?
                                    <StyledTableRow key={wo.uuid}>
                                      <StyledTableCell >
                                          {wo.uuid}
                                      </StyledTableCell>
                                      <StyledTableCell>
                                          {wo.hostname}
                                      </StyledTableCell>
                                      <StyledTableCell >
                                          {wo?.user?.fullName}
                                      </StyledTableCell>
                                      <StyledTableCell>
                                        {wo.isEnabled ? "Activo" : "Inactivo"}
                                      </StyledTableCell>
                                      <StyledTableCell>
                                        <div style={{ display: 'flex' }}>
                                            <Chip size="small"
                                                icon={<Edit fontSize="small" />}
                                                variant="outlined"
                                                color='primary'
                                                disabled={state.isEditing || state.isCreating}
                                                onClick={() => prepareEdit(wo)}
                                                label={t("elements.buttons.edit")}
                                            />{/*
                                            <div style={{ marginLeft: "0.5em" }} />
                                            <Chip size="small"
                                                icon={<Delete fontSize="small" />}
                                                onClick={() => handleDelete(wo)}
                                                label={t("elements.buttons.delete")}
                                                disabled={state.isEditing || state.isCreating}
                                                variant="outlined"
                                                color="error"
                                            >
                                                <DeleteOutline fontSize="small" />
                                            </Chip>
                                            */}
                                        </div>
                                    </StyledTableCell>
                                  </StyledTableRow> :
                                  <StyledTableRow key={wo.uuid}>
                                    <StyledTableCell colSpan={5}>
                                      <Grid container spacing={1}>
                                        <Grid item xs={3.5}>
                                          <TextField 
                                              id={"field-uuid-edi"}
                                              name="name"
                                              size="small"
                                              disabled
                                              value={formik.values.uuid}
                                              fullWidth
                                              sx={{ background: '#F5F5F5'}}
                                          />
                                        </Grid>
                                        <Grid item xs={2}>
                                          <TextField 
                                              id={"field-uuid-edi"}
                                              name="name"
                                              size="small"
                                              disabled
                                              value={formik.values.hostname}
                                              fullWidth
                                              sx={{ background: '#F5F5F5'}}
                                          />
                                        </Grid>
                                        <Grid item xs={2.5}>
                                          <TrueffortInputLabel shrink labelString={"Usuarios"} />
                                          <Select
                                              placeholder={"Seleccione el usuario"}
                                              value={userValue}
                                              options={users}
                                              onChange={(option) => setUserValue(option)}
                                              styles={styleReactSelect}
                                          />
                                        </Grid>
                                        <Grid item xs={2}>
                                          <FormControlLabel control={<Switch color='success'
                                            checked={isEnabledW}
                                            onChange={(ev) => setIsEnabledW(ev.target.checked)}
                                          />} label={t("workstation.enabled")} />
                                        </Grid>
                                        <Grid item xs={2} style={{
                                            display: "flex", alignItems: "flex-end", justifyContent: "center"
                                        }}>
                                            <Stack spacing={1} direction={{ xs: 'column', lg: 'row' }} >
                                                <Chip size="small"
                                                    icon={<Save fontSize="small" />}
                                                    variant="outlined"
                                                    color='success'
                                                    onClick={() => handleEdit(formik.values)}
                                                    label={t("elements.buttons.save")}
                                                />

                                                <Chip size="small"
                                                    icon={<Clear fontSize="small" />}
                                                    onClick={() => {
                                                        wo["isEditing"] = false;
                                                        formik.resetForm();
                                                        setState({ ...state, isEditing: false });
                                                    }}
                                                    label={t("elements.buttons.cancel")}
                                                    variant="outlined"
                                                    color="error"
                                                />
                                            </Stack>
                                        </Grid>
                                      </Grid>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                  ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div style={{ width:'100%', justifyContent: 'flex-end' }}>
                          <Box sx={{ display: 'flex', justifyContent: "flex-end", 
                              alignItems: "center", marginTop: '1em' }}>
                              <TablePagination
                                  labelRowsPerPage={t("elements.pagination.label")}
                                  rowsPerPageOptions={[5,10,15]}
                                  component={"div"}
                                  onRowsPerPageChange={handleChangeProfilesRowsPerPage}
                                  onPageChange={handleChangeworkstationsPage}
                                  count={workstationsCount}
                                  rowsPerPage={rowsPerPageWorkstation}
                                  page={workstationsPage}
                              />
                          </Box>
                        </div>
                    </Grid>
                </TrueffortCardTable>}
            </Grid>
        </Card>
    );
}

export default WorkstationInvisibleTab;
